import { useContext } from "react";
import SPPositionContext from "../contexts/SPPositionProvider";

const useSPPosition = () => {
  return useContext(SPPositionContext);
};

export default useSPPosition;
